import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type DailyAvgRowProps = {
  currentAvg: number;
  prevMonthAvg: number;
  lastYearAvg: number;
  lastYearLabel: string;
};

const formatAvg = (value: number) => {
  if (value >= 100 || value % 1 === 0) return Math.round(value).toLocaleString();
  return value.toFixed(1);
};

export const DailyAvgRow = ({ currentAvg, prevMonthAvg, lastYearAvg, lastYearLabel }: DailyAvgRowProps) => {
  const { t } = useTranslation();
  return (
    <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: '0.5px' }}>
      {formatAvg(currentAvg)}/{t('dashboard.avgPerDay')}
      {' · '}
      {t('dashboard.prevMonth')}: {formatAvg(prevMonthAvg)}
      {' · '}
      {lastYearLabel}: {formatAvg(lastYearAvg)}
    </Typography>
  );
};
